import React, { useState } from 'react';

import Login from '../Login';
import Dashboard from '../Dashboard';

const App = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    return (
      <>
        {isAuthenticated ? (
          <Dashboard setIsAuthenticated={setIsAuthenticated} />
        ) : (
          <Login setIsAuthenticated={setIsAuthenticated} />
        )}
      </>
    );
};

export default App;